// MySubmissionsActionMenu.jsx
import { useState } from 'react';
import { Tooltip, IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

/**
 * Props:
 *   row      – the submission row object (must contain row.id and row.formId / row.urlSlug
 *              so the parent can build the navigation URL)
 *   onEdit   – called with (row) → parent navigates to edit URL
 *   onView   – called with (row) → parent opens a view/detail dialog or page
 */
export default function MySubmissionsActionMenu({ row, onEdit, onView }) {
    const [anchor, setAnchor] = useState(null);
    const open = Boolean(anchor);

    const handleClose = () => setAnchor(null);

    return (
        <>
            <Tooltip title="Actions" placement="left">
                <IconButton
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        setAnchor(e.currentTarget);
                    }}
                    sx={{
                        color: 'text.secondary',
                        '&:hover': { color: 'primary.main', backgroundColor: '#e3f2fd' },
                    }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </Tooltip>

            <Menu
                anchorEl={anchor}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                disableScrollLock
                disableAutoFocusItem
                PaperProps={{
                    elevation: 2,
                    sx: { minWidth: 180, borderRadius: 2, border: '1px solid #e0e0e0' },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {/* Edit — navigates to edit URL with submissionId */}
                <MenuItem
                    onClick={() => onEdit(row)}
                    dense
                    sx={{ fontSize: '0.875rem', py: 1 }}
                >
                    <ListItemIcon sx={{ minWidth: 32 }}>
                        <EditOutlinedIcon fontSize="small" color="primary" />
                    </ListItemIcon>
                    <ListItemText>Edit</ListItemText>
                </MenuItem>

                {/* View — opens read-only view */}
                <MenuItem
                    onClick={() => onView(row)}
                    dense
                    sx={{ fontSize: '0.875rem', py: 1 }}
                >
                    <ListItemIcon sx={{ minWidth: 32 }}>
                        <VisibilityOutlinedIcon fontSize="small" color="action" />
                    </ListItemIcon>
                    <ListItemText>View Form Data</ListItemText>
                </MenuItem>
            </Menu>
        </>
    );
}